import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Testimonialkinekt() {
  return (
    <section className="testimonial-kinekt p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2 className="head-h2-kinekt">
              Client’s <span style={{ color: "#20A2BE" }}>Testimonial</span>
            </h2>
            <h4>
              How Gratitude App has achieved more engagement rate of users
              across the age.
            </h4>
            <p>
              Erika finds MindInventory a unique and reliable team of creative
              designers to continue work with that has helped bring her dream
              app into reality, which is playing a pivotal role in helping users
              showcase gratitude.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <StaticImage
              src="../../../images/case-studies/kinekt-new/client-test.webp"
              alt="TekRevol"
              className="logo_amj"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={716}
              height={471}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Testimonialkinekt;
